// extracted by mini-css-extract-plugin
export default {"NavigateTab":"NavigateTab_NavigateTab__VlaXL","btn":"NavigateTab_btn__5ANTi","btn_solid":"NavigateTab_btn_solid__cEOXV","btn_transparent":"NavigateTab_btn_transparent__tlEsY"};